import { render, staticRenderFns } from "./UnitCert.vue?vue&type=template&id=3506660e"
import script from "./UnitCert.vue?vue&type=script&lang=js"
export * from "./UnitCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports